import React, { createContext, useContext, useState, useCallback } from 'react';

const LocationContext = createContext();

const LOCATIONS = [
  { key: 'all', label: 'All Locations', short: 'All', color: '#6B7280', bg: '#F3F4F6' },
  { key: 'll',  label: 'Lonsdale',      short: 'LL',  color: '#7C3AED', bg: '#EDE9FE', centerId: '68f9a3f8-4927-4808-b91a-68f71a47d771' },
  { key: 'mh',  label: 'Mountain Hwy',  short: 'MH',  color: '#2563EB', bg: '#DBEAFE', centerId: 'bb3035e6-32a2-451a-95ba-de4f281ceb8e' },
  { key: 'wv',  label: 'West Vancouver', short: 'WV',  color: '#059669', bg: '#D1FAE5', centerId: '099f4638-5eaa-4528-8730-54ee7b22555b' },
];

export function LocationProvider({ children }) {
  const [location, setLocationState] = useState(() => {
    try {
      return localStorage.getItem('ops-location') || 'all';
    } catch {
      return 'all';
    }
  });

  const setLocation = useCallback((loc) => {
    setLocationState(loc);
    try {
      localStorage.setItem('ops-location', loc);
    } catch {}
  }, []);

  const current = LOCATIONS.find(l => l.key === location) || LOCATIONS[0];
  const centerId = current.centerId || null;

  return (
    <LocationContext.Provider value={{ location, setLocation, current, centerId, LOCATIONS }}>
      {children}
    </LocationContext.Provider>
  );
}

export function useLocation() {
  const ctx = useContext(LocationContext);
  if (!ctx) throw new Error('useLocation must be used within LocationProvider');
  return ctx;
}

export { LOCATIONS };
